<template>
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <div class="h4 mb-1">
                        {{ dto.title }}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="p-1 bg-white">
                        <div class="row">
                            <div class="col-6 px-1">
                                <p class="mb-0 fw-bold" v-html="dto.recurringPriceDescriptionHtml" />
                            </div>
                            <div class="col-6 px-1">
                                <Price
                                    :price="dto.recurringPrice.price"
                                    :initial-price="dto.recurringPrice.initialPrice"
                                    :price-details="dto.recurringPrice.priceDetails ? dto.recurringPrice.priceDetails : undefined"
                                    :show-from="dto.recurringPrice.showFrom"
                                    :show-by-month="dto.recurringPrice.showByMonth"
                                    :show-promo-duration="dto.recurringPrice.showPromoDuration"
                                    :show-end-of-promotion-price="dto.recurringPrice.showEndOfPromotionPrice"
                                    :duration="dto.recurringPrice.duration"
                                    :is-cents-format="false"
                                    :is-compact="true"
                                />
                            </div>
                        </div>
                        <div v-if="dto.internetDiscountEligibilityMessage">
                            <p class="alert alert-info fw-normal">
                                <span class="alert-icon" aria-hidden="true" />
                                <span class="ob1-alert-title" v-text="dto.internetDiscountEligibilityMessage" />
                            </p>
                        </div>
                        <div v-if="dto.onBillPrice" class="row mt-1">
                            <div class="col-6 px-1">
                                <p class="mb-0 fw-bold" v-html="dto.onBillPriceDescriptionHtml" />
                            </div>
                            <div class="col-6 px-1">
                                <Price
                                    :price="dto.onBillPrice.price"
                                    :initial-price="dto.onBillPrice.initialPrice"
                                    :price-details="dto.onBillPrice.priceDetails ? dto.onBillPrice.priceDetails : undefined"
                                    :show-from="dto.onBillPrice.showFrom"
                                    :show-by-month="dto.onBillPrice.showByMonth"
                                    :show-promo-duration="dto.onBillPrice.showPromoDuration"
                                    :show-end-of-promotion-price="dto.onBillPrice.showEndOfPromotionPrice"
                                    :duration="dto.onBillPrice.duration"
                                    :is-cents-format="false"
                                    :is-compact="true"
                                />
                            </div>
                        </div>
                        <div v-if="dto.totalFeesPrice" class="row mt-1 d-flex align-items-baseline">
                            <div class="col-6 px-1">
                                <p class="mb-0 fw-bold text-gray3" v-html="dto.totalFeesPriceDescriptionHtml" />
                            </div>
                            <div class="col-6 px-1">
                                <template v-if="dto.totalFeesPrice.price === 0">
                                    <span class="text-gray3" v-html="dto.freeFeesLabel" />
                                </template>
                                <template v-else>
                                    <Price
                                        :price="dto.totalFeesPrice.price"
                                        :initial-price="dto.totalFeesPrice.initialPrice"
                                        :price-details="dto.totalFeesPrice.priceDetails ? dto.totalFeesPrice.priceDetails : undefined"
                                        :show-from="dto.totalFeesPrice.showFrom"
                                        :show-by-month="dto.totalFeesPrice.showByMonth"
                                        :show-promo-duration="dto.totalFeesPrice.showPromoDuration"
                                        :show-end-of-promotion-price="dto.totalFeesPrice.showEndOfPromotionPrice"
                                        :duration="dto.totalFeesPrice.duration"
                                        :is-cents-format="false"
                                        :is-mini="true"
                                        :custom="'text-gray3'"
                                    />
                                </template>
                            </div>
                        </div>

                        <div v-if="dto.priceDetailsPopin">
                            <Lien
                                :label="dto.priceDetailsPopin.linkLabel"
                                :is-button="true"
                                :is-link-arrow="true"
                                :data-test-id="'btn-price-detail'"
                                modal-id="cart-recap-multiple-price-details"
                                :tms-category="'reprise_panier_avec_offre'"
                                :tms-action="dto.priceDetailsPopin.linkLabel"
                                :tms-label="priceDetailsPopinTmsLabel"
                            />

                            <MultiplePriceDetailsPopin
                                modal-id="cart-recap-multiple-price-details"
                                :price-details="dto.priceDetailsPopin"
                            />
                        </div>
                    </div>

                    <div ref="ctaBlock" class="mt-1 bg-white">
                        <div class="row">
                            <div class="col-12 px-1 d-flex flex-column align-items-center ">
                                <div v-if="dto.doubleEquipmentAlertMessage">
                                    <p class="alert alert-danger">
                                        <span class="alert-icon" aria-hidden="true" />
                                        <span class="ob1-alert-title" v-text="dto.doubleEquipmentAlertMessage" />
                                    </p>
                                </div>
                                <div v-if="dto.isDeviceOutOfStock">
                                    <p class="alert alert-warning">
                                        <span class="alert-icon" aria-hidden="true" />
                                        <span class="ob1-alert-title">Le terminal n'est plus disponible. Veuillez retirer le terminal de votre panier ou en choisir un autre.</span>
                                    </p>
                                </div>
                                <CartPageOrderCta
                                    :dto="dto"
                                    :is-disabled="hasDoubleEquipmentOnCart || dto.isDeviceOutOfStock"
                                />
                                <CartPageSharing
                                    v-if="dto.cartSharing"
                                    :cart-description="dto.cartSharing.description"
                                    :cart-url="dto.cartSharing.url"
                                    :icon-from-svg="dto.cartSharing.iconFromSvg"
                                    :authenticated-cart-message="dto.cartSharing.authenticatedMessage"
                                />
                            </div>
                        </div>
                    </div>

                    <!--/* CTA fixé en mode mobile uniquement, quand le block 'commander' est hors du viewport */-->
                    <div v-if="isCtaOutOfViewport" class="p-1 bg-white fixed-bottom d-lg-none">
                        <CartPageOrderCta
                            :dto="dto"
                            :is-disabled="hasDoubleEquipmentOnCart || dto.isDeviceOutOfStock"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Price from "../../components/ob1/Price.vue";
import CartPageSharing from "./CartPageSharing.vue";
import CartPageOrderCta from './CartPageOrderCta.vue';
import MultiplePriceDetailsPopin from "./MultiplePriceDetailsPopin.vue";
import Lien from "../../components/ob1/Lien.vue";

export default {
    name: 'CartPageRecap',
    components: {
        Lien,
        MultiplePriceDetailsPopin,
        CartPageSharing,
        Price,
        CartPageOrderCta
    },
    props: {
        dto: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isCtaOutOfViewport: false,
            ctaObserver: null,
        }
    },
    computed: {
        hasDoubleEquipmentOnCart() {
            return this.dto.doubleEquipmentAlertMessage?.length > 0
        },
        priceDetailsPopinTmsLabel() {
            return toBroadbandTmsFormat(this.dto.priceDetailsPopin.linkLabel);
        },
    },
    mounted() {
        if (!('IntersectionObserver' in window) || !this.$refs.ctaBlock) {
            this.isCtaOutOfViewport = false;
            return;
        }
        this.ctaObserver = new IntersectionObserver(
            ([entry]) => {
                this.isCtaOutOfViewport = !entry.isIntersecting && entry.boundingClientRect.top > 0;
            }
        );
        this.ctaObserver.observe(this.$refs.ctaBlock);
    },
    beforeDestroy() {
        if (this.ctaObserver) {
            this.ctaObserver.disconnect();
            this.ctaObserver = null;
        }
    },
}
</script>
